import http from "../http";
import { ICadastral, IParamsCadastral, IUpload } from "./types";

export const apiUtilsCadastral = (params?: IParamsCadastral) =>
  http.get<BaseAPIResponse<Array<ICadastral>>>("/api/utils/cadastral_vn", {
    params,
  });

export const apiUtilsUploadSingle = (body: File) => {
  const formData = new FormData();
  formData.append("images", body);
  return http.post<BaseAPIResponse<GenericData<IUpload>>>(
    "/uploads",
    formData,
    {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    }
  );
};

export const apiUtilsMultiple = (body: Array<File>) => {
  const formData = new FormData();
  body.forEach((x) => {
    formData.append(`images`, x);
  });

  return http.post<BaseAPIResponse<{ result: IUpload[] }>>(
    "/uploads",
    formData,
    {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    }
  );
};
